// extracted by mini-css-extract-plugin
export default {"formHeading":"XI-z","form":"YI-z","submitBtn":"ZI-z","disabled":"_I-z","input":"aJ-z","error":"bJ-z","submitMsg":"cJ-z","signIn":"dJ-z"};